import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <Navigation />
      <div className="hero">
        <h1>Welcome to the Apocalypse</h1>
        <p className="subtitle">A World of Chaos and Resilience</p>
      </div>
      <div className="container">
        <div className="intro-section">
          <h2>The World</h2>
          <p>
            In a <span className="accent-word">post-apocalyptic world</span> ravaged by chaos and cosmic purges, 
            humanity fights to survive. Amidst the ruins and destruction, the 
            <span className="accent-word"> ChaosTamers</span> emerged—a group of unlikely allies including humans, 
            aliens, robots, and hybrids who chose to band together rather than succumb to the darkness.
          </p>
          <p>
            Standing in opposition to the ChaosTamers are the <span className="accent-word">Purgers</span>—a militant order 
            of angels and demons led by <span className="accent-word">Lucienna Lightstepper</span>. They believe in the 
            divine mandate of purification, viewing the apocalypse as a necessary cleansing of corruption. Their goal is 
            to eradicate all that they deem impure, seeing themselves as instruments of cosmic judgment in a world that 
            has lost its way.
          </p>
          <p>
            Behind the chaos lies the <span className="accent-word">mysterious Tribunal</span>—an interdimensional force 
            whose true motives remain shrouded in mystery. Their stated purpose is the complete eradication of all life 
            on Earth, but the reasons behind this decree are unknown. Some speculate that humanity represents a cancer 
            threatening the universe's balance, while others believe the Tribunal has deeper, more complex motives that 
            no one truly understands. What is certain is that their judgment has unleashed angels, demons, and alien 
            forces upon the world, turning Earth into a battleground for cosmic forces beyond mortal comprehension.
          </p>
          <p>
            Yet not all beings follow the paths laid out for them. Some angels, demons, aliens, machines, and humans 
            have chosen to <span className="accent-word">forge their own destinies</span>—rejecting their assigned 
            purposes to fight for survival, freedom, or personal motives. These independent souls navigate the wasteland 
            on their own terms, whether as lone wanderers, mercenaries, or those simply trying to make sense of a world 
            where the old rules no longer apply.
          </p>
          <div className="button-group">
            <a 
              href="https://janitorai.com/characters/71610f52-6ee6-4746-938a-a543c6a94b08_character-tribunal-cosmic-surge-apocalypse-origin-event"
              className="btn btn-primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              Try to Survive
            </a>
            <Link to="/characters" className="btn btn-primary">
              Meet the Characters
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;

